module.exports = __webpack_public_path__ + "img/29-image-1-1@2x.f54eef7a.png";